import React from 'react';
import MainLayout from '../components/Layout/MainLayout.js';

const PolicyPage = () => {
    return (
        <MainLayout>
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-8">Privatlivspolitik</h1>
                
                <div className="prose prose-lg">
                    <h2>1. Dataansvarlig</h2>
                    <p>HåndværkerNet er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig.</p>

                    <h2>2. Hvilke data indsamler vi?</h2>
                    <ul>
                        <li>Virksomhedsoplysninger (CVR, firmanavn, adresse)</li>
                        <li>Kontaktoplysninger (email, telefonnummer)</li>
                        <li>Billeder uploadet til hjemmesiden</li>
                        <li>Indhold oprettet på hjemmesiden</li>
                    </ul>

                    <h2>3. Formål med databehandlingen</h2>
                    <p>Vi behandler dine oplysninger for at:</p>
                    <ul>
                        <li>Oprette og administrere din hjemmeside</li>
                        <li>Sende servicebeskeder om din konto</li>
                        <li>Forbedre vores tjenester</li>
                        <li>Overholde lovkrav</li>
                    </ul>

                    <h2>4. Opbevaring og sikkerhed</h2>
                    <p>Vi opbevarer dine data sikkert hos vores cloud-udbydere Firebase og Vercel. Data opbevares inden for EU/EØS.</p>

                    <h2>5. Dine rettigheder</h2>
                    <p>Du har ret til at:</p>
                    <ul>
                        <li>Få indsigt i dine data</li>
                        <li>Få rettet ukorrekte oplysninger</li>
                        <li>Få slettet dine data</li>
                        <li>Gøre indsigelse mod behandlingen</li>
                    </ul>

                    <h2>6. Kontakt</h2>
                    <p>Har du spørgsmål om vores behandling af dine oplysninger, er du velkommen til at kontakte os på <a href="mailto:kontakt@haandvaerkernet.dk">kontakt@haandvaerkernet.dk</a></p>
                </div>
            </div>
        </MainLayout>
    );
};

export default PolicyPage;